export type TransactionDetails = {
  key: string
  transactionId: string
  transactionType: string
  transactionHash?: string | null
  transactionHashUrl?: string | null
  walletType: string
  method: string
  accountHolderName?: string | null
  amount: { prefix: string; postfix: string }
  fee: string
  tax?: string | null
  netAmount: { prefix: string; postfix: string }
  currency: { source: string; destination: string }
  createdDate: string
  completedDate: string
  status: string
  transaction_status: string
  note?: string | null
  sourceDestination?: { source: string; destination: string } | null
  merchantDescription?: string | null
  failureReason?: string | null
  blockedReasons?: string | null
  manualAssignments?: Array<{
    createdAt: string
    amount: { prefix: string; postfix: string }
    status: string
    externalId: string
  }> | null
  network?: string | null
  bankAccountNo: string | null
  bankName: string | null
  bankSwiftCode?: string | null
  transferRemark?: string | null
  isDeclarationRequired: boolean | null
  webhookAvailable: boolean
  approvalDetails: ApprovalDetails | null
  userRemarks: string | null
}

export enum APPROVAL_STATUS_ENUM {
  PENDING = 'pending_approval',
  REJECTED = 'rejected',
  APPROVED = 'approved',
}

export type ApprovalDetails = {
  approvalNeed: number
  overallStatus: APPROVAL_STATUS_ENUM
  overallStatusVerbose: string
  maker: {
    fullName: string
    email: string
    makedAt: string
  }
  checkers: ApprovalChecker[]
  expiresAt: string
}
export enum APPROVAL_CHECKER_STATUS_ENUM {
  APPROVED = 'approved',
  REJECTED = 'rejected',
}
export type APPROVAL_CHECKER_STATUS =
  | APPROVAL_CHECKER_STATUS_ENUM.APPROVED
  | APPROVAL_CHECKER_STATUS_ENUM.REJECTED
export type ApprovalChecker = {
  fullName: string
  email: string
  approvalStatus: APPROVAL_CHECKER_STATUS
  notes: string
  checkedAt: string
}

export enum TRANSACTION_DETAILS_ACTIONS {
  SET_IS_LOADING = 'TRANSACTION_DETAILS_ACTIONS.SET_IS_LOADING',
  GET_TRANSACTION_DETAILS = 'TRANSACTION_DETAILS_ACTIONS.GET_TRANSACTION_DETAILS',
}

type SetIsLoading = {
  type: typeof TRANSACTION_DETAILS_ACTIONS.SET_IS_LOADING
  isLoading: boolean
}

type getTransactionDetails = {
  type: typeof TRANSACTION_DETAILS_ACTIONS.GET_TRANSACTION_DETAILS
  transactionDetails: TransactionDetails
}

export type ActionTypes = SetIsLoading | getTransactionDetails
